.root {
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  align-items: center;
  gap: var(--space-2) var(--space-3);
  color: inherit;
  font-size: var(--mantine-font-size-sm);
  line-height: var(--mantine-line-height-sm);
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.root strong {
  font-weight: inherit;
}

.label,
.separator,
.root strong:not([data-complete]) .current {
  font-weight: 400;
  opacity: 0.75;
}

.root > span {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  white-space: nowrap;
}

.root img {
  width: var(--space-5);
  height: var(--space-5);
  flex: none;
  object-fit: contain;
}
